// Copyright (c) 2022 by Move Closer

import { CanHaveTheme, UseThemeClassProvides } from '../../composables'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface ProgressBarProps extends CanHaveTheme {
  maxValue: number
  value: number
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export enum ProgressBarTheme {
  Default = 'default',
  Primary = 'primary'
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export type UseProgressBarProvides = UseThemeClassProvides
